// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsSurvey = {
    "aws_appsync_graphqlEndpoint": "https://nt4rbe45uzdkff4gwzts6gbxta.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-gpiu4fl26jhu3f6fl7yzqi2tbq",
};

export default awsSurvey;